import { IconButton, Tooltip, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { useEffect, useState } from "react"
import OneModal from "../../../../../Components/OneModal/OneModal"
import BaixarEntrega from "../BaixarEntrega/BaixarEntrega.jsx"
import { containerEntrega, sxColum, sxTypografy } from "./sxEntrega"
import ListClickToCall from "../../../VisitadosTab/CardPessoa/ListClickToCall"
import InfoEntrega from "../InfoEntrega/InfoEntrega.jsx"
import EnviarMsgModal from "../../../../../Components/EnviarMsgModal/EnviarMsgModal"
import { Send } from "@mui/icons-material"
import { IconSx } from "../../../VisitadosTab/CardPessoa/CardPessoa"
import OneCheckbox2 from "../../../../../Components/OneCheckbox2/OneCheckbox2"
import NovaEntrega from "../NovaEntrega/NovaEntrega.jsx"
import EditIcon from '@mui/icons-material/Edit'

const Entrega = ({ index, entrega }) => {
    const [checked, setChecked] = useState(false)
    const [openModalBaixaEntrega, setOpenModalBaixaEntrega] = useState(false)
    const [openModalInfo, setOpoenModalInfo] = useState(false)
    const [openEnviarMsg, setOpenEnviarMsg] = useState(false)
    const [editEncomenda, setEditEncomenda] = useState(false)

    useEffect(() => {
        setChecked(entrega.status == 1)
    }, [entrega])

    const handleChangeChecked = () => {
        if (!checked) {
            setOpenModalBaixaEntrega(true)
        }
    }

    const editarEncomenda = () => {
        setEditEncomenda(!editEncomenda)
    }

    let dados = entrega
    let unidade1 = dados?.unidade1 == undefined || dados?.unidade1 == null ? '' : dados?.unidade1
    let unidade2 = dados?.unidade2 == undefined || dados?.unidade2 == null ? '' : dados?.unidade2
    let imovel = unidade1 + ' - ' + unidade2
    dados.imovel = imovel
    dados.NOME = dados.morador
    dados.CD_ACESSO = dados.cd_acesso

    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={containerEntrega} container>
            <Grid xs={0.7} sm={0.7} md={0.7} lg={0.9} xl={0.7} sx={sxColum}>
                <Typography sx={sxTypografy}>{dados.id_encomenda}</Typography>
            </Grid>

            <Grid xs={2} sm={3} md={2.4} lg={2} xl={2.7} sx={{ padding: '1px 10px', display: 'flex' }}>
                <OneCheckbox2 checked={checked} disabled={checked} onChange={handleChangeChecked} labelSize="20px" text={dados.NOME || "SEM DESTINATÁRIO"} tooltipText={'Baixar Entrega'} newSx={!dados.NOME ? { color: '#a1a1a1' } : {} }/>
            </Grid>

            <Grid xs={12} sm={1.5} md={1.5} lg={1.5} xl={1.5} sx={sxColum}>
                <Typography sx={sxTypografy}>{imovel}</Typography>
            </Grid>

            <Grid xs={1} sm={1} md={1} lg={0.7} xl={1} sx={sxColum}>
                <Typography sx={sxTypografy}>{dados.codigo_rastreio}</Typography>
            </Grid>

            <Grid xs={2} sm={1.5} md={2} lg={2} xl={1.5} sx={sxColum}>
                <Typography sx={sxTypografy}>{dados.tipo}</Typography>
            </Grid>

            <Grid xs={1} sm={1.5} md={1.5} lg={1.5} xl={1} sx={sxColum}>
                <Typography sx={sxTypografy}>{dados.origem}</Typography>
            </Grid>

            <Grid xs={1} sm={1.8} md={1.8} lg={1.5} xl={1.5} sx={sxColum}>
                <Typography sx={{ ...sxTypografy, ...{ fontSize: '15px' } }}>{dados.data_cadastro}</Typography>
            </Grid>

            <Grid xs={1.5} sm={1} md={1} lg={1.5} xl={2} sx={sxColum} gap={0.5}>
                <Tooltip title='Enviar mensagem' placement='bottom' arrow>
                    <Send sx={IconSx} onClick={() => { setOpenEnviarMsg(true) }} />
                </Tooltip>

                <ListClickToCall key={index} pessoa={dados} ramalImovel={dados.ramal} tooltipText='Ligar para o destinatário' tooltipPosition="bottom" tipo_licenca_cond={dados.tipo_licenca_cond} ></ListClickToCall>

                <Tooltip title='Mais informações' placement='bottom' arrow>
                    <InfoOutlinedIcon sx={IconSx} onClick={() => setOpoenModalInfo(!openModalInfo)}></InfoOutlinedIcon>
                </Tooltip>

                <Tooltip title='Editar' placement='bottom' arrow>
                    <IconButton sx={{ color: 'black' }} onClick={editarEncomenda}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            </Grid>

            <OneModal
                open={openModalBaixaEntrega}
                setOpen={setOpenModalBaixaEntrega}
                titleText={'Baixar Entrega'}
                fullWidth = {true}
                onClose={false}
            >
                <BaixarEntrega encomenda={dados} setChecked={setChecked} handleChangeChecked={handleChangeChecked} setOpenModalBaixaEntrega={setOpenModalBaixaEntrega}/>
            </OneModal>

            {
                openModalInfo &&
                <InfoEntrega id_encomenda={dados.id_encomenda} setOpoenModalInfo={setOpoenModalInfo} openModalInfo={openModalInfo}/>
            }

            {
                openEnviarMsg &&
                <EnviarMsgModal
                    openEnviarMsg={openEnviarMsg}
                    setOpenEnviarMsg={setOpenEnviarMsg}
                    pessoa={dados}
                />
            }

            <OneModal
                open={editEncomenda}
                setOpen={setEditEncomenda}
                titleText={'Editar uma Encomenda'}
                fullWidth={true}
                onClose={false}
            >
                <NovaEntrega
                    setOpenModalNovaEntrega={setEditEncomenda}
                    isModalOpen={editEncomenda}
                    resultEntregas={entrega}
                    idToEdit={entrega.id_encomenda}/>
            </OneModal>

        </Grid>
    )
}

export default Entrega
